import type { ReactNode } from 'react';

import { Overline } from '@/components/atoms/Eyebrow';

import styles from './FilterGroup.module.scss';

interface FilterGroupProps {
    legend: string;
    children: ReactNode;
}

export default function FilterGroup({ legend, children }: FilterGroupProps) {
    return (
        <fieldset className={styles.group}>
            <Overline as="legend" className={styles.legend}>
                {legend}
            </Overline>
            <div className={styles.fields}>{children}</div>
        </fieldset>
    );
}
